import Link from '@/components/Link/Link';
import tw, { styled } from 'twin.macro';

export const StyledLink = styled(Link)`
  ${tw`whitespace-nowrap`}
  ${tw`rounded-md`}
  ${tw`border-2`}
  ${tw`px-3 py-[12px]`}
`;

export const StyledCtaSection = styled.div<{ hasOneCTA: boolean; ctaIsOnNavBar?: boolean }>`
  ${tw`flex flex-col items-center justify-center`}
  ${tw`lg:justify-start lg:flex-row lg:flex-nowrap`}
  ${tw`lg:h-full`}
  ${tw`gap-2`}
  ${tw`lg:py-0`}
  ${({ ctaIsOnNavBar, hasOneCTA }) => {
    if (!ctaIsOnNavBar || !hasOneCTA) {
      return tw`pt-6 pb-[112px] lg:py-0`;
    }
    return tw`py-0`;
  }}
`;
